import { FunctionComponent, useState } from "react";
import { NextLink } from "../Links";
import { firstOrUndefined, Nil } from "cy-util";
import TabContent from "./TabContent";
import { useRouteState } from "../../hooks";
import { cn } from "../../utils/cn";
import { TabInfo } from "./models";

export interface TabProps {
  className?: string;
  selectedLabelClass?: string;
  tabs: TabInfo[];
  id: string;
  selected?: TabInfo | Nil;
  tabSelected: (tab: TabInfo) => void;
}

export const useTabs = (
  id: string,
  tabs: TabInfo[],
  {
    defaultKey,
    storeInRouter,
  }: { defaultKey?: string; storeInRouter?: boolean } = {},
) => {
  const key = `tab_${id}`;
  const [selectedRouterKey, setSelectedRouterKey] =
    useRouteState().useState(key);
  const [selectedStateKey, setSelectedStateKey] = useState<string>();
  const selectedKey = storeInRouter ? selectedRouterKey : selectedStateKey;
  const setSelectedKey = storeInRouter
    ? setSelectedRouterKey
    : setSelectedStateKey;
  const selected =
    tabs.find((x) => x.key === selectedKey) ||
    tabs.find((x) => x.key == defaultKey) ||
    firstOrUndefined(tabs);

  function setSelected(newTab: TabInfo) {
    setSelectedKey(newTab.key);
  }

  return {
    tabs,
    id,
    selected,
    selectedKey: selectedKey,
    tabSelected: setSelected,
  };
};

/**
 * @todo
 * overflow tabs
 */
const TabRoot: FunctionComponent<TabProps> = ({
  className,
  tabs,
  selected,
  tabSelected,
  selectedLabelClass,
}) => {
  return (
    <div className={cn(className)}>
      <div className="border-b border-gray-200 text-center text-sm font-medium text-gray-500">
        <ul className="-mb-px flex overflow-x-auto">
          {(tabs || []).map((tab) => {
            const isSelected = tab.key === selected?.key;
            return (
              <li key={tab.key} className="mr-2 cursor-pointer">
                <NextLink
                  href={tab.href}
                  onClick={(_) => tabSelected(tab)}
                  className={cn(
                    "inline-block rounded-t-lg border-b-4 border-transparent p-4 uppercase",
                    isSelected &&
                      cn(
                        selectedLabelClass ||
                          "text-primary-500 border-primary-500",
                      ),
                    !isSelected && "hover:border-gray-300 hover:text-gray-600",
                  )}
                >
                  {tab.label}
                </NextLink>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export const Tab = Object.assign(TabRoot, { Content: TabContent });
